import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=750a6ba5&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=750a6ba5&prod&lang=less&scoped=true"
import style1 from "./DetailTable.vue?vue&type=style&index=1&id=750a6ba5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a6ba5",
  null
  
)

export default component.exports